import event, {EVENTS} from '../lib/event';

let workspace;

const getWorkspace = () => workspace;

event.on(EVENTS.WORKSPACE_INIT, wkspace => {
    console.log('workspaceInit');
    workspace = wkspace;
    window.workspace = wkspace;
});

export {
    getWorkspace
};
